import Bounds from 'nanogl-pbr/Bounds'

import { ScrollSide } from '@/webgl/runner/entities/BackgroundEntity'
import { CollectibleData } from '@/webgl/runner/entities/CollectibleEntity'
import { ScenarioSetup } from '@/webgl/runner/scenarios/ScenarioSetup.types'

export default class GameRegistry {
  scrolls: ScrollItemRegistry = new ScrollItemRegistry()
  collectibles: CollectibleRegistry = new CollectibleRegistry()

  init(setup: ScenarioSetup) {
    this.scrolls.register(setup.background.items)
    this.collectibles.register(setup.collectibles.items)
  }
}

export type ScrollItemMeta = {
  id: string
  side?: ScrollSide
  scale?: number
  bounds?: Bounds
}

export class ScrollItemRegistry {
  items: ScrollItemMeta[] = []
  count(): number {
    return this.items.length
  }

  setBounds(id: string, bounds: Bounds) {
    const itemIndex = this.items.findIndex((i) => i.id === id)
    if (itemIndex < 0) return
    this.items[itemIndex].bounds = bounds
  }

  get(id: string): ScrollItemMeta {
    const item = this.items.find((i) => i.id === id)
    return item
  }

  has(id: string): boolean {
    return this.items.find((i) => i.id === id) != null
  }

  register(metas: ScrollItemMeta[]) {
    for (const meta of metas) {
      this.add(meta)
    }
  }

  add(data: ScrollItemMeta) {
    this.items.push(data)
  }

  getItemForSide(side: ScrollSide, include?: string[]): ScrollItemMeta {
    const items = this.items.filter((item) => {
      return (
        (item.side === undefined || item.side == ScrollSide.ANY || item.side === side) &&
        (!include || (include.length != 0 && include.indexOf(item.id) != -1))
      )
    })
    if (items.length == 0) {
      return null
    }
    return items[Math.floor(Math.random() * items.length)]
  }
}

export class CollectibleRegistry {
  collectibles: CollectibleData[] = []

  count(): number {
    return this.collectibles.length
  }

  register(collectibles: CollectibleData[]) {
    for (const collectible of collectibles) {
      this.add(collectible)
    }
  }

  add(data: CollectibleData) {
    this.collectibles.push(data)
  }

  remove(data: CollectibleData) {
    const idx = this.collectibles.indexOf(data)
    this.collectibles.splice(idx, 1)
  }

  get(id: string): CollectibleData | null {
    const data = this.collectibles.find((c) => c.id === id)
    if (!data) throw new Error(`Collectible ${id} not found`)
    return data
  }

  getRandomCollectible(): CollectibleData {
    return this.collectibles[Math.floor(Math.random() * this.collectibles.length)]
  }
}
